"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventCategories = void 0;
exports.eventCategories = [
    "AutoCompounding",
    "LiquidityChange",
    "WithdrawV2",
];
//# sourceMappingURL=types.js.map